export default __webpack_public_path__ + "static/media/Menu.c5b3d5e2.svg";